import React, { useEffect, useState } from "react";
import { Tabs,Button, Row , Col, message} from "antd";
import './render-tabs.style.scss';
import { StickyContainer, Sticky } from 'react-sticky';
import Icon from '@ant-design/icons';
import Inactivecalender from './../../../images/inactive-calender.png';
import ActiveCalender from './../../../images/active-calender.png';
import { ScheduleActiveExtend } from "./schedule-active-extend.component";
import { ScheduleEditFareExtend } from "./schedule-edit-fare.component";
import { ScheduleTripDetailsExtend } from "./schedule-trip-details.component";
import { ScheduleAmenities } from './schedule-amenities.component';
import { checkDynamicPricingEnabled, checkToViewTripDetailsTab } from "./render-tabs.module";
import { NewTimingTab } from "../../new-timing/new-timing-component/new-timing.component";
import { showUpdatebtn } from "../../../utils/constant";
import { DynamicPricingTabComponent } from "./dynamic-pricing-tab.component";
import { ValidateTripButton } from "../../validate-trip-button/validate-trip-button.component";
import { tripCreateReducerSelector } from "../../../selector/trip-create.selector";
import { useSelector } from "react-redux";
import { CloneScheduleComponent } from "../../clone-schedule-component/clone-schedule.component";
import { EditTripComponent } from "../../edit-trip/edit-trip-component";
import { MarkScheduleInactive } from "./mark-in-active.component";
import { AdvanceBookingDays } from "../advance-booking-days/advance-booking-days";
import { ScheduleVehicleComponent } from "./schedule-vehicle.component";
import { ScheduleChangeLayout } from "./schedule-change-layout.component";
import { isChangeLayoutTabAllowed } from "../../admin-tab/admin-tab.module";
import { ExportScheduleToExcel } from "../export-schedule-to-excel/export-schedule-to-excel";
import { checkActionAllowed } from "../../../utils/utilities";
import { ACTION_EXPORT_SCHEDULE_EXCEL, ACTION_VIEW_SCHEDULE_COMMISSION_TAB } from "../../../utils/constant";
import { ScheduleLogsTab } from "../../schedule-logs-component/schedule-logs-tab.component";
import { ScheduleCommission } from "./schedule-commission.component";

const { TabPane } = Tabs;


const renderTabBar = (props, DefaultTabBar) => (
    <Sticky bottomOffset={80}>
      {({ style }) => (
        <DefaultTabBar {...props} className="site-custom-tab-bar"  />
      )}
    </Sticky>
  );

export const RenderTabs = (props) => {

        const{
            selectedDate,
            scheduleData,
            isMobile,
            amenities,
            fetchAmenities,
            defaultActiveKey=null,
            reload,
            inActiveReload,
            defaultActiveTab=null
        } = props;

        //if schedule-activation is used in tabType then it will be open by default

        const [isScheduleOpened , setIsscheduleOpened] = useState(defaultActiveTab==`${scheduleData.id}${"schedule-activation"}`?true:false);
        const [tabkey , setTabKey] = useState(defaultActiveTab==`${scheduleData.id}${"schedule-activation"}`?null:defaultActiveTab);

        const tripCreateReducer = useSelector(tripCreateReducerSelector);

        let { busesData } = tripCreateReducer;

        let selectSchedule = <div className="select-schedule-button-root">
                                <Button 
                                className={isScheduleOpened?"active-outline-button select-schedule-button":"select-schedule-button"} 
                                onClick={()=>{
                                    setIsscheduleOpened(!isScheduleOpened);
                                    setTabKey(null);
                                }} 
                                ghost={isScheduleOpened}
                                >
                                    {isScheduleOpened?
                                    <Icon component={() => (<img src={ActiveCalender} className='calender-icon' />)} />
                                    :
                                    <Icon component={() => (<img src={Inactivecalender} className='calender-icon' />)} />
                                    }
                                </Button>
                                </div>

        let editFareKey = `${scheduleData.id}${"edit-fare"}`;
        let StopsKey = `${scheduleData.id}${"stops"}`;
        let dynamicPricingKey = `${scheduleData.id}${"dynamic-pricing"}`;
        let amenitiesKey = `${scheduleData.id}${"amenities-tab"}`;
        let manageTabKey = `${scheduleData.id}${"manage"}`;
        let vehicleInfoKey = `${scheduleData.id}${"vehicle-info"}`;

        let tripDetailsKey = `${scheduleData.id}${"trip-details"}`;
        let isEditFareOpened = editFareKey === tabkey ? true :false;
        let isStopsOpened = StopsKey === tabkey ? true :false;
        let isAmenitiesOpened = amenitiesKey === tabkey ? true :false;
        let isTripDetailsOpened = tripDetailsKey === tabkey ? true: false;
        let isManageOpened = manageTabKey === tabkey ? true :false;
        let isDynamicPricingOpened = dynamicPricingKey === tabkey ? true :false;
        let isVehicleInfoOpened = vehicleInfoKey === tabkey ? true : false;

        let changeLayoutKey = `${scheduleData.id}${"change-layout"}`;
        let isChangeLayoutOpened = changeLayoutKey === tabkey ? true : false;

        let logsKey = `${scheduleData.id}${"logs"}`;
        let isLogsOpened = logsKey === tabkey ? true : false;

        let commissionKey = `${scheduleData.id}${"commission"}`;
        let isCommissionOpened = commissionKey === tabkey ? true : false;

        let editFare = <div className={"edit-fare-block"}>
                            <Button 
                            className={isEditFareOpened?"selected-edit-fare-outline-btn":"edit-fare-outline-button"}>
                                    Edit Fare
                            </Button>
                        </div>;

        let stops = <div className={"edit-fare-block"}>
                    <Button 
                    className={isStopsOpened?"selected-edit-fare-outline-btn":"edit-fare-outline-button"}>
                            Stops
                    </Button>
                    </div>;

        let dynamicPricing = <div className={"edit-fare-block"}>
                        <Button 
                        className={isDynamicPricingOpened?"selected-edit-fare-outline-btn":"edit-fare-outline-button"}>
                                Dynamic Pricing
                        </Button>
                    </div>;

        let amenitiesTab = <div>
                            <Button
                            className={isAmenitiesOpened?"selected-edit-fare-outline-btn":"edit-fare-outline-button"}>
                                    Amenities
                            </Button>
                        </div>;

        let manageTab = <div>
                            <Button
                            className={isManageOpened?"selected-edit-fare-outline-btn":"edit-fare-outline-button"}>
                                    Manage
                            </Button>
                        </div>;

        let vehicleInfoTab = <div className={"edit-fare-block"}>
                                <Button
                                className={isVehicleInfoOpened?"selected-edit-fare-outline-btn":"edit-fare-outline-button"}>
                                        Vehicle Info
                                </Button>
                            </div>;

        let tripDetails = <div className={"edit-fare-block"}>
                            <Button className={isTripDetailsOpened?"selected-edit-fare-outline-btn":"edit-fare-outline-button"}>
                                Trip Details
                            </Button>
                        </div>;

        let changeLayoutTab = <div className={"edit-fare-block"}>
                            <Button
                            className={isChangeLayoutOpened?"selected-edit-fare-outline-btn":"edit-fare-outline-button"}>
                                    Change Layout
                            </Button>
                        </div>;

        let logsTab = <div className={"edit-fare-block"}>
                            <Button
                            className={isLogsOpened?"selected-edit-fare-outline-btn":"edit-fare-outline-button"}>
                                    Logs
                            </Button>
                        </div>;

        let commissionTab = <div className={"edit-fare-block"}>
                            <Button
                            className={isCommissionOpened?"selected-edit-fare-outline-btn":"edit-fare-outline-button"}>
                                    Commission
                            </Button>
                        </div>;

        return(
            <div>
                <StickyContainer>
                    <Tabs 
                        tabBarExtraContent={selectSchedule} 
                        destroyInactiveTabPane={true}
                        className={'tabs-in-schedules'}
                        renderTabBar={renderTabBar}
                        defaultActiveKey={defaultActiveKey}
                        activeKey={`${tabkey}`}
                        onTabClick={(currentKey)=>{
                            setIsscheduleOpened(false);
                            if(currentKey === tabkey){
                                setTabKey(null);
                            }else{
                                setTabKey(currentKey);
                            }
                        }}
                        onChange={(currentKey)=>{

                        }}
                    >
                        <TabPane tab={vehicleInfoTab} key={vehicleInfoKey}>
                            <ScheduleVehicleComponent
                                scheduleData={scheduleData}
                                selectedDate={selectedDate}
                            />
                        </TabPane>
                        {isChangeLayoutTabAllowed()&&<TabPane tab={changeLayoutTab} key={changeLayoutKey}>
                            <ScheduleChangeLayout
                                scheduleData={scheduleData}
                                selectedDate={selectedDate}
                            />
                        </TabPane>}
                        <Tabs.TabPane tab={amenitiesTab} key={amenitiesKey}>
                            <ScheduleAmenities
                                scheduleData={scheduleData}
                                isAmenitiesOpened={isAmenitiesOpened}
                                amenities = {amenities}
                                fetchAmenities = {fetchAmenities}
                           />
                        </Tabs.TabPane>
                        <Tabs.TabPane tab={manageTab} key={manageTabKey}>
                            <div className="extend-block-root">

                                <Row gutter={[16,16]}>
                                    <Col>
                                        <EditTripComponent 
                                            scheduleId={scheduleData.id}
                                            recreationRequired={true}
                                        />
                                    </Col>
                                    <Col>
                                        <ValidateTripButton 
                                            scheduleId={scheduleData.id}
                                        />
                                    </Col>
                                    <Col>
                                        <CloneScheduleComponent
                                            busesData={busesData}
                                            formData={scheduleData}
                                            onCloneSuccess={()=>{
                                                inActiveReload();
                                            }}
                                            isReturnSchedule={true}
                                        />
                                    </Col>
                                    <Col>
                                        <CloneScheduleComponent
                                            busesData={busesData}
                                            formData={scheduleData}
                                            onCloneSuccess={()=>{
                                                inActiveReload();
                                            }}
                                            isReturnSchedule={false}
                                        />
                                    </Col>
                                    <Col>
                                        <MarkScheduleInactive 
                                            scheduleId={scheduleData.id}
                                            onSuccess={reload}
                                            onFailure={(errmsg)=>{message.error(errmsg);}}
                                        />
                                    </Col>
                                    <Col>
                                        <AdvanceBookingDays
                                            scheduleId={scheduleData.id}
                                            onSuccess={reload}
                                            advanceBookingDays={scheduleData.advance_booking_days}
                                            defaultFareByWeekday={scheduleData.default_fare_by_weekday}
                                        />
                                    </Col>
                                    {checkActionAllowed(ACTION_EXPORT_SCHEDULE_EXCEL)&&<Col>
                                        <ExportScheduleToExcel 
                                            scheduleId={scheduleData.id}
                                        />
                                    </Col>}
                                </Row>
                            </div>
                        </Tabs.TabPane>
                        {checkToViewTripDetailsTab()&&
                        <TabPane tab={tripDetails} key={tripDetailsKey}>
                           <ScheduleTripDetailsExtend
                                selectedDate={selectedDate}
                                scheduleData={scheduleData}
                                isMobile={isMobile}
                                isTripDetailsOpened={isTripDetailsOpened}
                           />
                        </TabPane>}
                        {/* <Tabs.TabPane tab="Routes" key="Routes">
                            Routes
                        </Tabs.TabPane> */}
                        <TabPane tab={editFare} key={editFareKey}>
                           <ScheduleEditFareExtend 
                                selectedDate={selectedDate}
                                scheduleData={scheduleData}
                                isMobile={isMobile}
                                isEditFareOpened={isEditFareOpened}
                           />
                        </TabPane>
                        <TabPane tab={stops} key={StopsKey}>
                             <NewTimingTab
                                scheduleId={scheduleData.id}
                                isDaySpecificExits={false}
                                scheduleDescription={scheduleData.description}
                                showUpdateBtns={showUpdatebtn()}
                                selectedDate={selectedDate}
                                importFrom={'schedulePage'}
                                scheduleData={scheduleData}
                                isStopsOpened={isStopsOpened}
                            />
                        </TabPane>
                        {checkDynamicPricingEnabled(scheduleData)&&
                            <TabPane tab={dynamicPricing} key={dynamicPricingKey}>
                                <DynamicPricingTabComponent
                                    selectedDate={selectedDate}
                                    scheduleData={scheduleData}
                                    isMobile={isMobile}
                                    isDynamicPricingOpened={isDynamicPricingOpened}
                                />
                            </TabPane>
                        }
                        {checkActionAllowed(ACTION_VIEW_SCHEDULE_COMMISSION_TAB)&&
                        <TabPane tab={commissionTab} key={commissionKey}>
                            <ScheduleCommission
                                scheduleData={scheduleData}
                                isCommissionOpened={isCommissionOpened}
                            />
                        </TabPane>}
                        <TabPane tab={logsTab} key={logsKey}>
                            <ScheduleLogsTab
                                scheduleId={scheduleData.id}
                                scheduleDescription={scheduleData.description}
                            />
                        </TabPane>
                    </Tabs>
                </StickyContainer>
                {isScheduleOpened&&
                <ScheduleActiveExtend 
                    selectedDate={selectedDate}
                    scheduleData={scheduleData}
                    isMobile={isMobile}
                    isScheduleOpened={isScheduleOpened}
                />
                }
            </div>
        )
}
